import { render, staticRenderFns } from "./LabelContractsTopSlot.vue?vue&type=template&id=583a5f92"
import script from "./LabelContractsTopSlot.vue?vue&type=script&lang=js"
export * from "./LabelContractsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports